import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Flower2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32" data-testid="not-found-page">
      <div className="max-w-xl">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#B38728] font-mono mb-4 flex items-center gap-2"><Flower2 className="h-4 w-4" /> {t("Error 404")}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#194324] leading-tight">{t("Page not found")}</h1>
        <p className="mt-5 text-[#3A4E41] leading-relaxed">{t("The page you are looking for does not exist or may have been moved.")}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/"><Button className="rounded-full bg-[#194324] hover:bg-[#2D623A] text-white font-semibold h-11 px-6" data-testid="not-found-home-button">{t("Back to Home")}</Button></Link>
          <Link to="/contact"><Button variant="outline" className="rounded-full h-11 px-6 border-[#194324]/30 text-[#194324]" data-testid="not-found-contact-button">{t("Contact Us")}</Button></Link>
        </div>
      </div>
    </section>
  );
}
